export const CONSENTS: Record<string, ConsentKeys> = {
    necessary: "necessary",
    preferences: "preferences",
    statistic: "statistics",
    marketing: "marketing",
};
export const ALL_CONSENTS : Array<ConsentKeys> = [
    CONSENTS.necessary,
    CONSENTS.statistic,
    CONSENTS.preferences,
    CONSENTS.marketing,
];

// Documentation for Cookiebot API
// https://www.cookiebot.com/en/developer/

export const UPDATED_CONSENT_EVENT_NAME = "CookiebotOnAccept";

type WindowWithData = {
    Cookiebot: CookieBotGlobalObject;
};

type ConsentData = {
        necessary: boolean;
        preferences: boolean;
        statistics: boolean;
        marketing: boolean;
    };
export type ConsentKeys = keyof(ConsentData);

export type CookieBotGlobalObject = {
    consent: ConsentData;
    consented: boolean;
    declined: boolean;
    hasResponse: boolean;
    doNotTrack: boolean;
    regulations: {
        gdprApplies: boolean;
        ccpaApplies: boolean;
        lgpdApplies: boolean;
    };

    show: () => void;
    hide: () => void;
    renew: () => void;
    withdraw: () => void;
    submitCustomConsent: (
        optinPreferences: boolean,
        optinStatistics: boolean,
        optinMarketing: boolean
    ) => void;
};

export function getCookiebot(): CookieBotGlobalObject {
    return (globalThis as unknown as WindowWithData).Cookiebot ?? null;
}

export function hasConsentFor(key: ConsentKeys): boolean {
    return getCookiebot()?.consent[key] ?? false;
}
